module.exports = __webpack_public_path__ + "img/lusher_blue.aec89a69.jpg";